import Reveal from "../components/Reveal";
import { SIGN_UP_URL } from "../config";
import { trackCta } from "../hooks/useMarketingAnalytics";
import AppStoreBadge from "../components/AppStoreBadge";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="py-24 lg:py-32 bg-[#22384F] text-white relative overflow-hidden">
      {/* Illustrative photograph — not a customer testimonial. */}
      <img
        aria-hidden="true"
        src="/marketing/final_cta_calm.webp"
        alt=""
        loading="lazy"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover opacity-20"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{ background: "linear-gradient(180deg, rgba(34,56,79,0.55) 0%, rgba(34,56,79,0.92) 100%)" }}
      />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center relative">
        <Reveal>
          <h2 className="font-display font-extrabold text-[34px] sm:text-[48px] leading-[1.05] tracking-[-0.025em] mb-6">
            Spend less time managing tools.
            <br />
            <span className="text-[#F0B67F]">Spend more time serving clients.</span>
          </h2>
        </Reveal>
        <Reveal delay={80}>
          <p className="text-[16px] sm:text-[17px] text-white/75 leading-relaxed max-w-2xl mx-auto mb-10">
            Bring your VA business into one organized workspace. Every client,
            every task, every document — in the right place.
          </p>
        </Reveal>
        <Reveal delay={140}>
          <a
            href={SIGN_UP_URL}
            data-testid="final-cta-button"
            onClick={() => trackCta("final_cta")}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#E8712C] hover:bg-[#C55A1F] text-white text-[16px] font-semibold shadow-[0_20px_40px_-15px_rgba(232,113,44,0.5)]"
          >
            Get started
          </a>
        </Reveal>
        <Reveal delay={200} className="mt-8">
          <AppStoreBadge source="final_cta" />
        </Reveal>
      </div>
    </section>
  );
}
